import { render, staticRenderFns } from "./ClinicProducts.vue?vue&type=template&id=66a06f16"
import script from "./ClinicProducts.vue?vue&type=script&lang=js"
export * from "./ClinicProducts.vue?vue&type=script&lang=js"
import style0 from "./ClinicProducts.vue?vue&type=style&index=0&id=66a06f16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports